import axios from "axios"
import { env } from "../constants"

/* Games */
export const games = (data) => {
    const uri = `${env.gamepoint}vip-three-box/game/list`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* View */
export const game = (data) => {
    const uri = `${env.gamepoint}vip-three-box/game/get`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Players */
export const players = (data) => {
    const uri = `${env.gamepoint}vip-three-box/game/players`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* View */
export const view = (data) => {
    const uri = `${env.gamepoint}vip-three-box/game/player-view`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Credit */
export const credit = (data) => {
    const uri = `${env.gamepoint}vip-three-box/game/credit`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Credit All */
export const creditAll = (data) => {
    const uri = `${env.gamepoint}vip-three-box/game/credit-all`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* GAMES LIST */
export const end = (data) => {
    const uri = `${env.gamepoint}vip-three-box/game/end-game`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* CHANGE PAUSE STATUS */
export const togglePause = (data) => {
    const uri = `${env.gamepoint}vip-three-box/game/toggle-pause-status`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}
